import csRagInstance from "./axios-instance";
import type {
  ChatEvent,
  ChatHistoryTurn,
  DeleteSourceResponse,
  Source,
  UploadResponse,
} from "./types";

/** SSE 스트리밍 채팅 — axios fetch adapter 기반 */
export async function* streamChat(
  question: string,
  signal?: AbortSignal,
  history: ChatHistoryTurn[] = [],
): AsyncGenerator<ChatEvent> {
  const response = await csRagInstance.post(
    "/chat",
    { question, history },
    {
      responseType: "stream",
      adapter: "fetch",
      signal,
    },
  );

  const reader = (response.data as ReadableStream)
    .pipeThrough(new TextDecoderStream())
    .getReader();

  let buffer = "";

  try {
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += value;

      let idx;
      while ((idx = buffer.indexOf("\n\n")) >= 0) {
        const raw = buffer.slice(0, idx);
        buffer = buffer.slice(idx + 2);
        if (!raw.startsWith("data:")) continue;
        const payload = raw.slice(5).trim();
        if (!payload) continue;

        try {
          yield JSON.parse(payload) as ChatEvent;
        } catch {
          // malformed JSON — skip
        }
      }
    }
  } finally {
    reader.releaseLock();
  }
}

export const getSources = async (): Promise<Source[]> => {
  const response = await csRagInstance.get<Source[]>("/admin/sources");
  return response.data;
};

export const postUploadSource = async (file: File): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  const response = await csRagInstance.post<UploadResponse>(
    "/admin/upload",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 300_000,
    },
  );
  return response.data;
};

export const deleteSource = async (
  sourceId: number,
): Promise<DeleteSourceResponse> => {
  const response = await csRagInstance.delete<DeleteSourceResponse>(
    `/admin/sources/${sourceId}`,
  );
  return response.data;
};
